import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetSensorDetailQuery } from '../../../../../redux/services/sensors';
import { useParams } from 'react-router-dom';
import { CollapseBlock, Spinner } from '../../../../common';
import { AppBarCMS } from '../../../../basic';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AttributePreview } from '../components/AttributePreview';
import { AttributeIconRenderer } from '../components/AttributeIconRenderer';
import PropTypes from 'prop-types';

export function SensorDetailPage() {
  const { t } = useTranslation();
  const { sensorId } = useParams();

  const { data: sensor, isLoading } = useGetSensorDetailQuery(sensorId);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={sensor.name}
        backUrl={routes.cmsMeteoStationSensors}
        backUrlTooltip={t('Správa senzorov')}
      />

      <div style={{ margin: '10px' }}>
        <CollapseBlock title={t('Senzor')} collapsible>
          <Cell title={t('Meno')} value={sensor.name} />
          <Cell
            title={t('Popis')}
            value={sensor.description}
            valueClassName="whitespace-pre-line"
          />
          <Cell title={t('IEEE Adresa')} value={sensor.ieee_address} />
        </CollapseBlock>
        <CollapseBlock title={t('Atribúty senzora')} collapsible>
          <div className="meteo-sensor-detail-attribute-preview-wrapper">
            {sensor.sensor_attributes.map((attribute) => (
              <AttributePreview
                key={attribute.id}
                title={attribute.label}
                value={attribute.sensor_value?.value}
                unit={attribute.attribute_unit.unit}
                icon={<AttributeIconRenderer attribute={attribute} />}
              />
            ))}
          </div>
        </CollapseBlock>
      </div>
    </>
  );
}

function Cell({ title, value, valueClassName = '' }) {
  return (
    <div className="meteo-sensor-detail-cell">
      <p className={`title`}>{title}</p>
      <p className={`value ${valueClassName}`}>{value}</p>
    </div>
  );
}

Cell.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  valueClassName: PropTypes.string,
};

export default SensorDetailPage;
